import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    width: {
      type: String,
      "default": "30px"
    },
    height: {
      type: String,
      "default": "30px"
    },
    color: {
      type: String,
      "default": "#D9D9D9"
    }
  },
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": "tui-loading",
        style: _normalizeStyle({
          width: __props.width,
          height: __props.height,
          border: "2px solid ".concat(__props.color),
          borderTopColor: 'transparent'
        })
      }, null, 4);
    };
  }
});